import { ValidateStringInput } from "../directives/validate-string-input.function";

export enum DocumentTypeEnum {
    RegularPdf = 'RegularPdf',
    XbrlPublicationVersionAnnualReport = "XbrlPublicationVersionAnnualReport",
    XbrlAuditorsReport = 'XbrlAuditorsReport',
    XbrlAuditorsReportSFO = 'XbrlAuditorsReportSFO',
    XbrlAssessmentStatement = 'XbrlAssessmentStatement',
    XbrlCompositionStatement = 'XbrlCompositionStatement',
    XbrlStatutoryVersionAnnualReport = "XbrlStatutoryVersionAnnualReport",
    XbrlNexusVersionAnnualReport = "XbrlNexusVersionAnnualReport",
    GenericTextFile = 'GenericTextFile',
    RegularXml = "RegularXml",
    DetachedSignature = "DetachedSignature",
    XbrlPreparerExtension = "XbrlPreparerExtension",
    PdfAudittrail = "PdfAudittrail",
    DNBStaat = "DNBStaat",
    ReferencedDocument = "ReferencedDocument",
    Json = "Json",
    JsonSignature = "JsonSignature",
    VatDeclaration = "VatDeclaration",
    VatCorrectionDeclaration = "VatCorrectionDeclaration",
    VatEuRecapitulativeStatement = "VatEuRecapitulativeStatement",
    IncomeTaxDeclaration = "IncomeTaxDeclaration",
    CorporateTaxDeclaration = "CorporateTaxDeclaration",
    SbrNexusSbvReport = "SbrNexusSbvReport",
    HTML = "HTML",
    SignatureStylesheet = "SignatureStylesheet",
    EnvelopingSignatureData = "EnvelopingSignatureData",
    XbrlNoabReport = "XbrlNoabReport",
    UnrenderedFile = "UnrenderedFile",

    /**
     * Our own GENERATED Audit Trail
     */
    AuditTrail = "AuditTrail",

    /**
     * Logs
     */
    LogFile = "LogFile",

    /**
     * Zip file containing big Styled xbrl
     */
    XbrlZip = "XbrlZip",
    /**
     * XbrlI or Inline XBRL (big xbrl)
     */
    XbrlInline = "XbrlInline",

    /**
     * Wage tax XML
     */
    WageTaxXml = "WageTaxXml",

    // EXTEND WHEN MORE OPTIONS FOUND

}
export const DocumentTypesForViewingAsHtml: DocumentTypeEnum[] = [
    DocumentTypeEnum.WageTaxXml,
    DocumentTypeEnum.XbrlInline,
    DocumentTypeEnum.XbrlZip,
    DocumentTypeEnum.LogFile,
    DocumentTypeEnum.GenericTextFile,

]
export const XbrlDocumentTypes: DocumentTypeEnum[] = [
    DocumentTypeEnum.XbrlPublicationVersionAnnualReport,
    DocumentTypeEnum.XbrlAuditorsReport,
    DocumentTypeEnum.XbrlAuditorsReportSFO,
    DocumentTypeEnum.XbrlAssessmentStatement,
    DocumentTypeEnum.XbrlCompositionStatement,
    DocumentTypeEnum.XbrlStatutoryVersionAnnualReport,
    DocumentTypeEnum.XbrlNexusVersionAnnualReport,
    DocumentTypeEnum.SbrNexusSbvReport,
    DocumentTypeEnum.VatDeclaration,
    DocumentTypeEnum.VatCorrectionDeclaration,
    DocumentTypeEnum.VatEuRecapitulativeStatement,
    DocumentTypeEnum.IncomeTaxDeclaration,
    DocumentTypeEnum.CorporateTaxDeclaration,
    DocumentTypeEnum.XbrlNoabReport,
    DocumentTypeEnum.WageTaxXml
]

/**
 * Validates the given input for being an 'PDF' RequestType(Enum)
 * @param inputValidation 
 * @returns 
 */
export function Is_Pdf_DocumentType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    return ValidateType(inputValidation as string, DocumentTypeEnum.RegularPdf);
}
/**
 * Validates the given input for being an 'PDF' RequestType(Enum)
 * @param inputValidation 
 * @returns 
 */
export function Is_Non_Pdf_DocumentType(inputValidation: string): boolean {
    if (!ValidateStringInput(inputValidation)) {
        return false;
    }

    return !ValidateType(inputValidation as string, DocumentTypeEnum.RegularPdf);
}


function ValidateType(inputValidation: string, asAction: DocumentTypeEnum): boolean {
    return inputValidation.trim().toLowerCase() == asAction.toLowerCase();
}